<template>
  <v-dialog v-model="dialog" width="1200px">
    <v-card>
      <v-card-title class="mx-3 pb-0">
        {{ $t("SupplierScoreBatch.title") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text class="pa-0 pl-10">
        {{ $t("SupplierScoreBatch.hint") }}
        &nbsp;&nbsp;
        <span class="red--text">{{ $t('SupplierScoreBatch.max_score', [max_score]) }}</span>
      </v-card-text>
      <v-divider></v-divider>
      <ValidationObserver ref="observer">
      <v-data-table
        :headers="headers"
        :items="suppliers"
        :loading="loading"
        :search="filter"
        multi-sort
        disable-pagination
        hide-default-footer
        class="elevation-0 px-6"
        fixed-header
        height="360px"
        v-resize="resizeHeader"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <v-spacer />
            <v-row no-gutters class="me-n3">
              <v-spacer />
              <v-col cols="12" sm="9" md="8">
                <v-text-field
                  v-model="filter"
                  clearable
                  hide-details
                  :label="$t('Search.filter')"
                />
              </v-col>
            </v-row>
          </v-toolbar>
          <v-divider />
        </template>
        <template v-slot:item.supply_type="{ item }">
          {{ item.supply_type }}
          <br />
          <span
             v-if="item.order_to_purchase == 1"
             class="text-no-wrap caption secondary--text"
             :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
          >
            {{ $t("Supplier.Fields.order_to_purchase") }}
          </span>
        </template>
        <template v-slot:item.after_sale_score="{ item }">
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('SupplierScoreBatch.Fields.after_sale_score')"
            :rules="{
               max_value: {max: max_score},
               min_value: {min: 0},
               required: {required: true}
            }"
          >
            <v-text-field
              v-model="item.after_sale_score"
              :error-messages="errors"
              single-line
              class="input-center"
            />
          </ValidationProvider>

        </template>
      </v-data-table>
      </ValidationObserver>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="primary"
          @click.stop="batchSave()"
        >
          {{ $t("CRUD.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Suppliers from "@/api/suppliers";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "DialogSupplierScore",

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  props: {
    value: Boolean,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("SupplierScoreBatch.Fields.supplier_code"),
          align: "start",
          sortable: false,
          value: "supplier_code",
        },
        {
          text: i18n.t("SupplierScoreBatch.Fields.supplier_name"),
          align: "start",
          sortable: false,
          value: "supplier_name",
        },
        {
          text: i18n.t("SupplierScoreBatch.Fields.supply_type"),
          align: "center",
          sortable: false,
          value: "supply_type",
        },
        {
          text: i18n.t("SupplierScoreBatch.Fields.after_sale_score"),
          align: "center",
          sortable: false,
          value: "after_sale_score",
          width: "150px",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    filter: "",
    suppliers: [],
    max_score: 0,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.getSuppliersFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.suppliers = [];
          this.filter = "";
        }
      },
    },

  },

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    getSuppliersFromAPI() {
      Suppliers.fetchAll({stop_flg:0}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.suppliers = response.data.suppliers
          }
        }.bind(this)
      );
      Suppliers.getCriteriaSetting().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.max_score = response.data.supplier_criteria_setting.supplier_scoring_criteria.artificial_score
          }
          this.itemsLoading = false;
        }.bind(this)
      );
    },

    batchSave() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            //校验成功再提交
            let data = [];
            this.suppliers.forEach((supplier) => {
              data.push({
                supplier_id: supplier.id,
                after_sale_score: supplier.after_sale_score
              })
            })
            Suppliers.scoreBatchSave(data).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$snackbar.success(i18n.t("SupplierCriteriaSetting.Messages.saveSuccess"));
                  this.dialog = false;
                  this.suppliers = [];
                  this.filter = "";
                  this.$emit("input", this.dialog);
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            ).catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    }
  },
};
</script>
